/* @flow */

import React from "react";
import { Dialogue } from "@crossroads/ui-components";
import { useTranslate } from "@awardit/react-use-translate";
import useShowLanguageSwitcher from "./use-show-language-switcher";
import Button from "components/Button";
import CloseIcon from "icons/cross.svg";
import styles from "./styles.scss";

import DenmarkIcon from "icons/denmark.svg";
import FinlandIcon from "icons/finland.svg";
import NorwayIcon from "icons/norway.svg";
import SwedenIcon from "icons/sweden.svg";

const LanguageSwitcher = (): React$Node => {
  const t = useTranslate();
  const showLanguageSwitcher = useShowLanguageSwitcher();

  if (!showLanguageSwitcher.open) {
    return null;
  }

  return (
    <Dialogue
      open
      id="languageSwitcher"
      setOpen={showLanguageSwitcher.setOpen}
      className={styles.dialogue}
    >
      <div className={styles.block}>
        <header>
          <div className={styles.headerContent}>
            <h1 lang="en">{t("LANGUAGE_SWITCHER.TITLE")}</h1>
            <p lang="en">{t("LANGUAGE_SWITCHER.SUB_TITLE")}</p>
          </div>
          <Button
            className={styles.close}
            aria-label={t("LANGUAGE_SWITCHER.CLOSE")}
            onClick={() => showLanguageSwitcher.setOpen(false)}
          >
            <CloseIcon aria-label={t("ICONS.CROSS")} />
          </Button>
        </header>
        <div className={styles.body}>
          <a href="/dk"><DenmarkIcon aria-label={t("ICONS.DENMARK_FLAG")} /><span lang="en">{t("LANGUAGE_SWITCHER.DENMARK")}</span></a>
          <a href="/fi"><FinlandIcon aria-label={t("ICONS.FINLAND_FLAG")} /><span lang="en">{t("LANGUAGE_SWITCHER.FINLAND")}</span></a>
          <a href="/no"><NorwayIcon aria-label={t("ICONS.NORWAY_FLAG")} /><span lang="en">{t("LANGUAGE_SWITCHER.NORWAY")}</span></a>
          <a href="/se"><SwedenIcon aria-label={t("ICONS.SWEDEN_FLAG")} /><span lang="en">{t("LANGUAGE_SWITCHER.SWEDEN")}</span></a>
        </div>
      </div>
    </Dialogue>
  );
};

export default LanguageSwitcher;
